// @flow weak

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { ListItem } from 'app/common/components/AccessibleElement';

const ChoiceListItem = createReactClass({
  displayName: 'ChoiceListItem',
  mixins: [PureRenderMixin],

  propTypes: {
    Item: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    isSelected: PropTypes.bool.isRequired,
    hasCustomChoiceHandlers: PropTypes.bool.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    className: PropTypes.string,
    onChoose: PropTypes.func.isRequired,
    onSoftChoose: PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      hasCustomChoiceHandlers: false,
    };
  },

  onChoose(e) {
    if (!this.props.hasCustomChoiceHandlers) {
      e.preventDefault();
    }
    if (!this.props.isDisabled) {
      this.props.onChoose(this.props.value);
    }
  },

  onSoftChoose() {
    if (!this.props.isDisabled) {
      this.props.onSoftChoose(this.props.value);
    }
  },

  render() {
    const { Item, className, ...props } = this.props;
    // If the `Item` does not define its own handlers
    // then attach handlers directly to the `li`.
    const ownHandlers =
      props.hasCustomChoiceHandlers && !props.isDisabled
        ? {}
        : {
            onClick: this.onChoose,
            onMouseEnter: this.onSoftChoose,
          };
    // If the `Item` defines its own handlers then
    // pass them along to `Item`.
    const customHandlers =
      !props.hasCustomChoiceHandlers && !props.isDisabled
        ? {}
        : {
            onChoose: this.onChoose,
            onSoftChoose: this.onSoftChoose,
          };
    return (
      <ListItem
        className={className}
        disabled={props.isDisabled}
        {...ownHandlers}
        role="menuitem"
        tabIndex={props.href ? -1 : 0}
      >
        <Item
          {..._.omit(
            props,
            'hasCustomChoiceHandlers',
            'onChoose',
            'onSoftChoose'
          )}
          {...customHandlers}
        />
      </ListItem>
    );
  },
});

export default ChoiceListItem;
